import React from 'react';
import './App.css';
import Footer from './components/Footer';
import Mision from './components/Mision';
import { Navbar } from './components/Navbar';
import ImageSlider from './components/ImageSlider';
import Vision from './components/Vision';

function App() {
  const slides = [
    { url: "https://i.ibb.co/ZXpg11F/banner.png", title: "banner"},
    { url: "https://i.ibb.co/99DFW9x/banner-2.png", title: "banner1" },
    { url: "https://i.ibb.co/x2NRDLs/banner2.png", title: "banner2" },
    { url: "https://i.ibb.co/MPSc2Gc/banner-publicitario-1-400-280-px.png", title: "banner3" },
  ];
  const containerStyles = {
    width: "400px",
    height: "280px",
    margin: "0 auto",
  }
  return (
    <>
    <Navbar></Navbar>
    <div style={containerStyles}>
        <ImageSlider slides={slides} />
      </div>
    <Mision/>
    <Vision/>
    <Footer/>
    </>
  );
}

export default App;
